import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21a1d4f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "utils__pageContainer auto__page" }
const _hoisted_2 = { class: "header-title" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_5 = { class: "content-title-left" }
const _hoisted_6 = {
  key: 0,
  class: "sign"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无消息", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, { class: "box-card" }, {
      title: _withCtx(() => [
        _createElementVNode("div", null, "平台消息" + _toDisplayString(_ctx.readStatusSum ? `（${_ctx.readStatusSum}）` : ''), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            style: _normalizeStyle({borderBottom: _ctx.messageAction === 1 ? '3px solid red' : ''}),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleTabs(1)))
          }, "全部", 4),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              style: _normalizeStyle({borderBottom: _ctx.messageAction === 2 ? '3px solid red' : ''}),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleTabs(2)))
            }, "只看未读消息", 4),
            _hoisted_4,
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleTabs(3)))
            }, "全部设为已读消息")
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        (_ctx.list && _ctx.list.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_a_collapse, {
                activeKey: _ctx.activeNames,
                "onUpdate:activeKey": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activeNames) = $event)),
                accordion: "",
                bordered: false,
                onChange: _ctx.handleChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                    return (_openBlock(), _createBlock(_component_a_collapse_panel, {
                      key: item.id,
                      "show-arrow": false
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(['content-title', !item.readStatus ? 'unread' : 'read'])
                        }, [
                          _createElementVNode("div", _hoisted_5, [
                            (!item.readStatus)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, _toDisplayString(item.title), 1)
                          ]),
                          _createElementVNode("div", null, _toDisplayString(item.sendTime && _ctx.timeFormat(new Date(item.sendTime), 'time')), 1)
                        ], 2)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(['content-content', !item.readStatus ? 'unread' : 'read']),
                          innerHTML: item.messageContent
                        }, null, 10, _hoisted_7)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["activeKey", "onChange"]),
              _createVNode(_component_a_pagination, {
                current: _ctx.pagination.page,
                "onUpdate:current": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pagination.page) = $event)),
                "page-size-options": ['10', '20', '30', '50'],
                total: _ctx.totalRow,
                "show-size-changer": "",
                "page-size": _ctx.pagination.pageSize,
                onChange: _ctx.currentChange,
                onShowSizeChange: _ctx.sizeChange
              }, null, 8, ["current", "total", "page-size", "onChange", "onShowSizeChange"])
            ], 64))
          : (_openBlock(), _createBlock(_component_a_empty, {
              key: 1,
              image: _ctx.simpleImage
            }, {
              description: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["image"]))
      ]),
      _: 1
    })
  ]))
}